import useSWR from 'swr'
import type { KeyedMutator } from 'swr'

// types
import type { AccountId } from 'types/auth'
import type { AccountsItem } from 'types/api/responses/enterprise'

import type { AxiosResponseType, CommonError } from 'types/api/responses/common'

import { fetchAccountDetails } from 'api/enterprise'

type Props = {
	accountId: AccountId
}
export default function useGetAccount({
	accountId,
}: Props): {
	data: void | AxiosResponseType<AccountsItem>
	error: void | CommonError
	mutate: KeyedMutator<AxiosResponseType<AccountsItem>>
} {
	const { data, error, mutate } = useSWR<AxiosResponseType<AccountsItem>, CommonError>([`/accounts/${accountId.value}`], () =>
		fetchAccountDetails({ accountId: accountId.value }),
	)

	return {
		data,
		error,
		mutate,
	}
}
